
export const PageVideo = ({ src }) => {
    return (
        <video className="page-video" controls name="media">
            <source src={src} type="video/mp4" />
            El navegador no soporta videos.
        </video>
    )
}
